import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {


  url = environment.serverAPI9 + "/api/leadActivity";

  constructor(private http: HttpClient) { }

  searchDynamicLeadReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/due${queryParams}`, requestBody);
  }

    searchActivityDue(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/activityDue${queryParams}`, requestBody);
  }

  searchActivityDueExcel(query: string, page: number, size: number, sort: string, groupBy: any, additionalQuery: any): Observable<any> {
    return this.searchActivityDue(query, page, size, sort, groupBy).pipe(
      map((res: any) => {
        let content = res['content'];
        if (content && additionalQuery && Array.isArray(additionalQuery)) {
          res['content'] = content.map((item: any) => {
            let newItem: any = {};
            for (let col of additionalQuery) {
              if (col.property === 'followupTime' && item[col.property]) {
                newItem[col.name] = this.convertToTwentyFourHourFormatExcel(item[col.property]);
              } else {
                newItem[col.name] = item[col.property];
              }
            }
            return newItem;
          });
        }
        return res;
      })
    );
  }

  private convertToTwentyFourHourFormatExcel(timeString: string): string {
    if (!timeString) return timeString;
    const match = timeString.match(/(\d+):(\d+)\s*(AM|PM|am|pm)/i);
    if (!match) return timeString;
    let [, hoursStr, minutes, modifier] = match;
    let hours = parseInt(hoursStr, 10);
    if (modifier.toUpperCase() === 'PM' && hours < 12) {
      hours = hours + 12;
    }
    if (modifier.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
    return `${hours.toString().padStart(2, '0')}:${minutes}`;
  }

  searchActivityDueCount(query: string, groupBy: any): Observable<any> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy
    };

    return this.http.post<any>(`${this.url}/activityDue/count`, requestBody);
  }


  searchTotalFollowUpPerUserChart(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/totalFollowUpPerUserChartdue${queryParams}`, requestBody);
  }

    searchTotalFollowUpPerUserChartPage(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/totalFollowUpPerUserChartdue/page${queryParams}`, requestBody);
  }

  searchTotalFollowUpUpcomingPerUser(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/totalFollowUpUpcomingPerUser${queryParams}`, requestBody);
  }

  
  searchTotalFollowUpUpcomingPerUserPage(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/totalFollowUpUpcomingPerUser/page${queryParams}`, requestBody);
  }

  searchDynamicLeadReportUser(query: string, page: number, size: number, sort: string, groupBy: any, userId: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/due/${userId}${queryParams}`, requestBody);
  }

  ActivityUpcomingReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/upcoming${queryParams}`, requestBody);
  }

    LeadActivityUpcomingReport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/activityUpcoming${queryParams}`, requestBody);
  }

  LeadActivityUpcomingCountReport(query: string, groupBy: any): Observable<any> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy
    };

    return this.http.post<any>(`${this.url}/activityUpcoming/count`, requestBody);
  }

  

  ActivityUpcomingReportByUser(query: string, page: number, size: number, sort: string, groupBy: any, userId: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/upcoming/${userId}${queryParams}`, requestBody);
  }


}
